import React from "react";
import styled from "styled-components";
import { projectCodenameSync } from "../../utils/codename";

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ProjectBlock = styled.div`
  padding: 16px;
  border: 1px solid var(--nd-border);
  border-radius: 8px;
  background: var(--nd-surface);
`;

const Codename = styled.div`
  font-family: 'Space Mono', monospace;
  font-size: 13px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--nd-text-display);
  margin-bottom: 4px;
`;

const Industry = styled.div`
  font-family: 'Space Mono', monospace;
  font-size: 10px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nd-text-disabled);
  margin-bottom: 12px;
`;

const JuniorList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
`;

const JuniorRow = styled.div`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 14px;
  color: var(--nd-text-primary);
`;

const NoJuniors = styled.div`
  font-family: 'Space Mono', monospace;
  font-size: 10px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nd-text-disabled);
`;

const StackRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

const StackChip = styled.span`
  font-family: 'Space Mono', monospace;
  font-size: 10px;
  letter-spacing: 0.04em;
  padding: 3px 7px;
  border-radius: 999px;
  border: 1px solid var(--nd-border-visible);
  color: var(--nd-text-secondary);
`;

const MobileList = ({ projects, members }) => {
  const memberById = new Map((members || []).map((m) => [m.id, m]));
  return (
    <Wrap>
      {projects.map((p) => {
        const here = (p.memberIds || [])
          .map((mid) => memberById.get(mid))
          .filter(Boolean);
        return (
          <ProjectBlock key={p.id}>
            <Codename>{projectCodenameSync(p.id)}</Codename>
            <Industry>{p.industry || "other"} · {p.status}</Industry>
            {here.length === 0 ? (
              <NoJuniors>no team assigned</NoJuniors>
            ) : (
              <JuniorList>
                {here.map((m) => (
                  <JuniorRow key={m.id}>{m.name}</JuniorRow>
                ))}
              </JuniorList>
            )}
            <StackRow>
              {(p.stack || []).map((t) => (
                <StackChip key={t}>{t}</StackChip>
              ))}
            </StackRow>
          </ProjectBlock>
        );
      })}
    </Wrap>
  );
};

export default MobileList;
